import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { textBuilder } from "@shared/helpers/text-builder";
import { sendMessageToRecipients } from "@shared/notifications/notifications-facade";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { Organization } from "../organization/entity";
import { type OrganizationManager } from "./entity";

export const OrganizationManagerEntityConfig: HyperEntityConfig<OrganizationManager> =
{
  allowApiCrud: [
    Roles.Manager,
    Roles.Admin,
    Roles.SuperAdmin,
    Roles.SuperDuperAdmin,
  ],
  allowApiRead: [
    Roles.User,
    Roles.Manager,
    Roles.Admin,
    Roles.SuperAdmin,
    Roles.SuperDuperAdmin,
  ],
  apiPrefilterPerRole: async (filter) => {
    if (!remult.user) return;

    filter(Roles.SuperDuperAdmin, true);

    filter([Roles.User, Roles.Manager, Roles.Admin, Roles.SuperAdmin], {
      organization: { $is: await copyApiPrefilterPerRole(Organization) },
    });
  },

  allowInsertPerRole(allow) {
    allow(Roles.SuperAdmin, {
      organization: {
        $id: remult.user!.organizationId,
      },
    });

    allow(Roles.SuperDuperAdmin, true);
  },

  allowDeletePerRole(allow) {
    allow(Roles.SuperAdmin, {
      organization: {
        $id: remult.user!.organizationId,
      },
    });
  },

  allowUpdatePerRole(allow) {
    allow(Roles.SuperAdmin, {
      organization: {
        $id: remult.user!.organizationId,
      },
    });

    allow(Roles.AdminsAndManager, (entity) => {
      return entity.id === remult.user!.id;
    });
  },

  async saving(entity, event) {
    if (!event.isNew && entity.id) {
      const existing = await event.repository.findId(entity.id);
      if (existing) {
        entity.phoneNumber = existing.phoneNumber;
      }
    }
  },

  async onInsert(entity, e) {
    const organization = await e.relations.organization.findOne();
    await sendMessageToRecipients(
      {
        message: textBuilder()
          .line(`שלום ${entity.name}`)
          .line(remult.user?.name ?? "המנהל")
          .space()
          .add("הוסיף אותך כמנהל בארגון ")
          .add(organization!.name)
          .line(".")
          .line("לכניסה למערכת WeMe יש ללחוץ על הקישור הבא:")
          .add("https://admin.weme.community")
          .done(),
      },
      [{ phoneNumber: entity.phoneNumber, email: "" }],
      ["sms"],
    );
  },
};
